module.exports = __webpack_public_path__ + "media/src/img/payment/sumbit-man-3d9758c11c5ab298057f0f142d31aa3e.svg";